import { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Send, Instagram, Mail, MapPin, Aperture } from "lucide-react";
import { api } from "@/lib/api";

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!form.name || !form.email || !form.message) { toast.error("Nom, email et message sont requis."); return; }
    setLoading(true);
    try {
      await api.post("/inquiries", form);
      toast.success("Message envoyé ! Réponse sous 24h.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (e) { toast.error("Une erreur est survenue."); }
    setLoading(false);
  };

  const inputCls = "w-full bg-[#0D0D0C] border border-[#F4F0EB]/10 rounded-lg px-4 py-3 font-sub text-sm text-[#F4F0EB] placeholder:text-[#6E695E] focus:border-[#C88D51]/60 focus:outline-none transition-colors";

  return (
    <section id="contact" className="py-24 lg:py-32 bg-[#0D0D0C]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16">
        <div>
          <div className="overline mb-4">Contact</div>
          <h2 className="font-serif-d text-4xl lg:text-6xl tracking-tight mb-8">Parlons de votre projet.</h2>
          <p className="font-sub text-[#A39E93] max-w-md mb-10 leading-relaxed">Une carte à mettre en images, un packaging, un reportage en cuisine ? Écrivez-moi, chaque projet commence par une conversation.</p>
          <div className="space-y-4 font-sub text-sm">
            <a href="mailto:contact@sel-lumiere.com" className="flex items-center gap-3 text-[#F4F0EB] hover:text-[#C88D51] transition-colors"><Mail className="w-4 h-4 text-[#C88D51]" /> contact@sel-lumiere.com</a>
            <div className="flex items-center gap-3 text-[#A39E93]"><MapPin className="w-4 h-4 text-[#C88D51]" /> Studio — 11e arrondissement, Paris</div>
            <a href="#" className="flex items-center gap-3 text-[#F4F0EB] hover:text-[#C88D51] transition-colors"><Instagram className="w-4 h-4 text-[#C88D51]" /> @sel.lumiere.studio</a>
          </div>
        </div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="bg-[#161513] border border-[#F4F0EB]/8 p-8 rounded-xl space-y-3">
          <input data-testid="contact-name" placeholder="Nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
          <input data-testid="contact-email" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} />
          <input placeholder="Sujet" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className={inputCls} />
          <textarea data-testid="contact-message" placeholder="Votre message…" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={inputCls} />
          <button data-testid="contact-submit" onClick={submit} disabled={loading} className="btn-accent w-full py-3.5 font-sub text-sm flex items-center justify-center gap-2 disabled:opacity-60">
            <Send className="w-4 h-4" /> Envoyer le message
          </button>
        </motion.div>
      </div>

      <footer className="max-w-[1400px] mx-auto px-6 lg:px-10 mt-24 pt-10 border-t border-[#F4F0EB]/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2"><Aperture className="w-4 h-4 text-[#C88D51]" /><span className="font-serif-d">Sel &amp; Lumière Studio</span></div>
        <div className="font-mono-a text-xs text-[#6E695E]">© 2026 Éléonore Vance — Tous droits réservés</div>
      </footer>
    </section>
  );
};
